import Link from "next/link";
import React from "react";
import { themeVariables } from "../themes/constants";
import Box from "./base/Box";
import PromotionIcon from "./icons/PromotionIcon";

interface TabProps {
  name: string;
  path: string;
  selected?: boolean;
  icon?: typeof PromotionIcon;
  onTabChange?: (key: string) => void;
}

const Tab: React.FC<TabProps> = (props) => {
  const {
    name,
    path,
    selected,
    icon: Icon,
    onTabChange = (key: string) => {},
  } = props;

  const color = selected
    ? themeVariables.colors.primary
    : themeVariables.colors.muted;

  return (
    <Box
      display="flex"
      flex={1 / 3}
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      onClick={() => onTabChange(path)}
    >
      {Icon && <Icon width={20} height={20} color={color} />}
      <Box color={color} mt={"2px"}>
        {name}
      </Box>
    </Box>
  );
};

export default React.memo(Tab);
